'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function SelectOption(_ref) {
  var name = _ref.name,
    value = _ref.value,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("option", {
    value: value,
    disabled: disabled
  }, name));
}
SelectOption.propTypes = {
  name: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  value: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  disabled: index.propTypes.exports.bool
};

exports.SelectOption = SelectOption;
